<!-- 公共组件-卡片头AI提示 -->
<template>
  <div class="tips">
    <img :src="aiLogo" />
    <div class="tips-text">
      <span v-if="mainText" class="text-color-main">{{ mainText }}</span>
      <span v-if="normalText" class="text-color-normal">{{ normalText }}</span>
    </div>
  </div>
</template>

<script setup>
import aiLogo from '@/assets/logo.svg'

defineProps({
  // 加粗文字
  mainText: {
    type: String,
    default: '加粗文字'
  },
  // 普通文字
  normalText: {
    type: String,
    default: '，普通文字'
  }
})
</script>

<style lang="scss" scoped>
.text-color-main {
  color: #323233;
}
.text-color-normal {
  color: #969799;
}
.tips {
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  &-text {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    color: #969799;
    margin-left: 8px;
  }
}
</style>
